import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CHART_TYPE_DEFINITIONS } from '../constants';

const EMPTY_STATE_ICON_STYLE = { fontSize: 48, opacity: 0.3 };

const EmptyState = ({ type }) => {
  const Icon = CHART_TYPE_DEFINITIONS[type]?.icon

  return(
  <div className="flex items-center justify-center h-full text-gray-400">
    <div className="text-center">
      {Icon && <Icon style={EMPTY_STATE_ICON_STYLE} />}
      <p className="mt-2 text-sm">
        <FormattedMessage
          id="NO_DATA_AVAILABLE"
          defaultMessage="No data available"
        />
      </p>
    </div>
  </div>
)};

export default EmptyState;
